


export const AuthorSection = () => (
  <div className="space-y-3">
    <h3 className="text-xs font-semibold uppercase text-muted-foreground">Author</h3>
    <select className="w-full border bg-background rounded px-3 py-1.5 text-sm">
      <option>Current User</option>
      <option>COLLECTIVE Staff</option>
    </select>
  </div>
);
